import { Component, OnDestroy, OnInit } from '@angular/core';
import { LMColumnsBaseComponent } from './lm-columns-base.component';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMFormLayoutService } from '@form/services/lm-form-layout.service';
import { LMLayoutUtilDirective } from './lm-layout-util.directive';
import { LMLoggerService } from '@app/services';

@Component({
  selector: 'lm-columns-image-first-column',
  templateUrl: 'lm-columns-image-first-column.component.html',
  styleUrls: [ './lm-columns-image-first-column.component.scss' ],
  providers: [ LMLayoutUtilDirective, LMFormLayoutService ]
})

export class LMColumnsImageFirstColumnComponent extends LMColumnsBaseComponent implements OnInit, OnDestroy {

  private subscribers = [];

  constructor(
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmFormLayoutService: LMFormLayoutService,
    protected lmLoggerService: LMLoggerService
  ) {
    super(lmConditionUtilService, lmFormLayoutService, lmLoggerService);
  }

  public columns: Array<LMFormLayoutColumnUi>;
  public imageColumn: Array<LMFormLayoutColumn> = [];

  ngOnInit() {
    super.ngOnInit();

    this.imageColumn.push(this.layoutObject.columns[0]);
    this.imageColumn.forEach((column, i) => {
      column.index = i;
    });

    this.layoutObject.columns.shift();

    this.layoutObject.columns.forEach((column, i) => {
      column.index = i;
    });
    this.columns = this.layoutObject.columns;
  }

  ngOnDestroy() {
    this.subscribers.forEach(subscription => subscription.unsubscribe());
  }
}
